import type { PortfolioData } from '../../firebase/types/portfolio.types';
import { detailedServices, filled } from './model';
import { Band, SectionIndex } from './ui';

export default function ServicesSection({ data, index }: { data: PortfolioData; index: string }) {
  const detailed = detailedServices(data);
  const simple = filled(data.services);

  if (detailed.length) {
    return (
      <Band id="services">
        <SectionIndex index={index} title="Services" />
        <div className="grid gap-3 md:grid-cols-2">
          {detailed.map((service, i) => (
            <article key={`${service.title}-${i}`} className="panel p-5">
              <h3 className="text-lg font-semibold tracking-tight">{service.title?.trim()}</h3>
              {service.description?.trim() ? (
                <p className="mt-3 whitespace-pre-line text-sm leading-relaxed text-muted md:text-base">
                  {service.description.trim()}
                </p>
              ) : null}
              {service.problemItSolves?.trim() ? (
                <p className="mt-3 text-sm leading-relaxed text-muted md:text-base">
                  <span className="text-ink">Problem. </span>
                  {service.problemItSolves.trim()}
                </p>
              ) : null}
              {service.whoItIsFor?.trim() ? (
                <p className="mt-3 text-sm leading-relaxed text-muted md:text-base">
                  <span className="text-ink">For. </span>
                  {service.whoItIsFor.trim()}
                </p>
              ) : null}
            </article>
          ))}
        </div>
      </Band>
    );
  }

  if (!simple.length) return null;

  return (
    <Band id="services">
      <SectionIndex index={index} title="Services" />
      <ol className="grid gap-3 sm:grid-cols-2">
        {simple.map((service, i) => (
          <li key={`${service}-${i}`} className="panel flex gap-3 p-4">
            <span className="text-sm font-medium text-signal">{String(i + 1).padStart(2, '0')}</span>
            <p className="text-base font-medium leading-snug text-ink">{service}</p>
          </li>
        ))}
      </ol>
    </Band>
  );
}
